import classNames from 'classnames'

import Image from '../ui/Image/Image'
import Markdown from '../Markdown/Markdown'

import Close from '../../assets/images/close.svg'
import { getImageUrl } from '../../utils'

import styles from './SafeBanking.module.scss'

const ModalContent = ({ data, handleClose }) => {
  const { dos_and_donts, fileinfo, title, description } = data

  return (
    <div>
      <div
        className={classNames(
          styles['close-container'],
          'flex justify-end pb-4 mb-4 md:pb-6 md:mb-6'
        )}
      >
        <img
          src={Close}
          alt="Close"
          className="object-none cursor-pointer h-6 w-6 md:h-8 md:w-8"
          onClick={handleClose}
        />
      </div>
      <div className={styles['safe-banking-modal']}>
        <div className={styles['title-image-wrapper']}>
          {title && <div className={styles['title']}>{title}</div>}
          {fileinfo && (
            <Image
              src={getImageUrl(fileinfo)}
              alt={title}
              className={styles['image']}
            />
          )}
        </div>
        {description && <Markdown content={description} />}
        {dos_and_donts && dos_and_donts?.length > 0 && (
          <div className={styles['info-container']}>
            {dos_and_donts?.map((eachdata) => {
              const imgKey = `${eachdata?.type}_image`
              const image = data?.[`${imgKey}`]
              return (
                <div key={eachdata?.id} className={styles['info-wrapper']}>
                  <div className={styles['info-image-wrapper']}>
                    {image && (
                      <Image
                        src={getImageUrl(image)}
                        alt={eachdata?.title}
                        className={styles['info-img']}
                      />
                    )}
                    {eachdata?.title && (
                      <div className={styles['info-title']}>
                        {eachdata?.title}
                      </div>
                    )}
                  </div>
                  {eachdata?.description && (
                    <Markdown content={eachdata?.description} />
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ModalContent
